<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text {{ $t('appointment_page_language') }}
  div.text-sm.font-normal.basic600--text {{ $t('appointment_page_language_desc') }}

  v-radio-group(v-model="languageSelection" hide-details)
    v-radio(value="en" color="basic700" )
      template(v-slot:label)
        div.text-md.font-normal.basic700--text English
    v-radio(value="ms" color="basic700")
      template(v-slot:label)
        div.text-md.font-normal.basic700--text Bahasa Melayu

  div.d-flex.mt-5
    v-spacer
    v-btn.button-md(color="neutral700" dark depressed :loading="isLoading" @click="saveData") {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EmbedDialog from '@/components/donation/dialogs/EmbedDialog.vue'

export default {
  name: 'GeneralPageLanguage',
  components: { EmbedDialog },
  data () {
    return {
      isLoading: false,
      languageSelection: null,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      form: 'clinic/getForm'
    }),
  },
  mounted () {
    this.languageSelection = this.form.language || 'en'
  },
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      this.isLoading = true
      const data = {
        language: this.languageSelection
      }
      this.$axios.patch(`/forms/${this.form.id}`, data)
        .then(() => {
          const form = { ...this.form, language: this.languageSelection }
          this.$store.commit('clinic/setForm', form)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }

}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>